<template>
  <div class="app-content">
    <div v-show="isShowNav">
      <!-- 自定义导航栏 -->
      <Nav></Nav>
      <!-- 自定义导航栏 -->
    </div>
    <div :class="isShowNav ? 'reset' : ''">
      <!-- <div :class="isShowNav?'tilte-text reset-header':'tilte-text'">
        修改密码
      </div> -->
      <div class="form-wrapper">
        <Form ref="settingForm" :model="settingForm" label-position="left" :label-width="110" :rules="ruleValidate">
          <FormItem label="手机号" :prop="isShowNav ? 'mobile' : ''">
            <span v-if="!isShowNav">{{ settingForm.mobile }}</span>
            <div v-else class="input-wrap">
              <Input v-model="settingForm.mobile" placeholder="请输入手机号码" />
            </div>
            <span class="btn mobile-btn" @click="sendSms">
              <div v-show="!showCountDown" class="code-btn">
                获取验证码
              </div>
              <div v-show="showCountDown" class="clock-btn">
                重新发送({{ countDown }})
              </div>
            </span>
          </FormItem>

          <FormItem label="验证码" prop="code">
            <div class="form-group">
              <div class="input-wrap">
                <Input v-model="settingForm.code" placeholder="请输入您收到的验证码" />
              </div>
              <div class="tip-wrapper">
                如有疑问，请联系在线客服
              </div>
            </div>
          </FormItem>
          <FormItem label="新密码" prop="password">
            <div class="form-group">
              <div class="input-wrap">
                <Input type="password" v-model="settingForm.password" placeholder="请输入新密码" />
              </div>
            </div>
          </FormItem>
          <FormItem label="确认密码" prop="repassword">
            <div class="form-group">
              <div class="input-wrap">
                <Input type="password" v-model="settingForm.repassword" placeholder="请再次输入新密码" />
              </div>
            </div>
          </FormItem>

          <div class="tilte-text" v-show="!isShowNav">
            开启客服
          </div>

          <FormItem label="是否开启客服" prop="isService" v-show="!isShowNav">
            <div class="form-group">
              <div class="input-wrap">
                <RadioGroup v-model="settingForm.isService">
                  <Radio label="1">
                    <span>开启</span>
                  </Radio>
                  <Radio label="0">
                    <span>不开启</span>
                  </Radio>
                </RadioGroup>
              </div>
              <div class="tip-wrapper">
                客服开启之后，您的影票推广页会显示官方客服。您的粉丝购票过程有疑问，可以联系官方客服
              </div>
            </div>
          </FormItem>

          <FormItem>
            <span class="active-btn confirm-btn" v-on:click="handleSubmit('settingForm')">确定修改</span>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { forgetPwdSms, forgetPwd, getUserInfo, setting } from '@/api/user'
import { Form, FormItem, Input, RadioGroup, Radio } from 'view-design'
import Nav from '@/components/Nav.vue'
export default {
  name: 'PromotionSetting',
  components: {
    Form,
    FormItem,
    Input,
    RadioGroup,
    Radio,
    Nav
  },
  data: function () {
    return {
      showCountDown: '',
      countDown: 60,
      loading: false,
      settingForm: {
        mobile: '',
        code: '',
        password: '',
        repassword: '',
        isService: '1',
        isForgetPassword: 0
      },
      routeName: "",
      ruleValidate: {
        mobile: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { pattern: /^[1][0-9]{10}$/, message: '请填写正确格式的手机号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请填写验证码', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '验证码请填写数字类型', trigger: 'blur' }
        ],

        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        repassword: [
          { required: true, message: '请再次填写密码', trigger: 'blur' }
        ],
        isService: [
          { required: true, message: '请勾选是否需要客服', trigger: 'change' }
        ]
      },
      redirect: undefined
    }
  },
  computed: {
    isShowNav: function () {
      this.routeName = this.$route.name;
      return (this.routeName == 'resetPwd' || this.routeName == 'pc/resetPwd')
    }
  },
  created() {
    var routeName = this.$route.name
    if (routeName != 'resetPwd' && routeName != 'pc/resetPwd') {
      this.getUserInfo();
      this.settingForm.isForgetPassword = 0;
    } else {
      this.settingForm.isForgetPassword = 1;
    }
    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect
    }
  },
  methods: {
    getUserInfo() {
      getUserInfo().then((response) => {
        this.settingForm.mobile = response.data.mobile
        this.settingForm.isService = response.data.is_open_server
      }).catch(error => {
        console.log(error)
      })
    },
    sendSms() {
      var isVaild = this.phoneFun(this.settingForm.mobile)
      if (!isVaild) {
        console.log("debug:________________手机号格式不正确______________");
        this.$Message.error('手机号格式不正确！')
        return
      }
      if (this.showCountDown) {
        return
      }
      this.showCountDown = true
      forgetPwdSms({
        nickname: this.nickname,
        mobile: this.settingForm.mobile,
        isForgetPassword: this.settingForm.isForgetPassword
      }).then(response => {
        this.$Message.success(response.message)
        this.timer = setInterval(() => {
          this.countDown--
          if (this.countDown === 0) {
            this.showCountDown = false
            this.countDown = 60;
            clearInterval(this.timer)
          }
        }, 1000)
      }).catch(error => {
        console.log(error)
        this.showCountDown = false
      })
    },
    phoneFun(phones) {
      var myreg = /^[1][0-9]{10}$/;
      if (!myreg.test(phones)) {
        return false;
      } else {
        return true;
      }
    },
    handleSubmit: function (formName) {
      if (this.loading) {
        return
      }
      if (this.settingForm.code !== '' && this.settingForm.password !== '' && this.settingForm.repassword !== '' && this.settingForm.isForgetPassword !== 0) {
        this.loading = true
        setting(this.settingForm).then(response => {
          console.log(response)
          this.loading = false
          this.$Message.success(response.message)
          this.settingForm.isService = response.data.is_open_server
          let that = this
          if (this.settingForm.isForgetPassword == 1) {
            setTimeout(function () {
              if (that.$store.state.user.isSaasProxyUser === 1) {
                that.$router.push({ path: '/pc/proxyHome/index' })
              } else {
                that.$router.push({ path: '/pc/login' })
              }
            }, 500)
          }
        }).catch(error => {
          this.loading = false
          console.log(error)
        })
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.settingForm.password != this.settingForm.repassword) {
              this.$Message.error('两次密码输入不一致')
              return
            }
            this.loading = true
            setting(this.settingForm).then(response => {
              this.loading = false
              this.$Message.success(response.message)
              this.$refs[formName].resetFields();
            }).catch(error => {
              this.loading = false
              console.log(error)
            })
          }
        })
      }
    },
  }
}
</script>
<style scoped>
.reset {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.reset .input-wrap {
  width: 4.45rem;
  margin-right: 0.2rem;
  display: inline-block;
}

.tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.tilte-text.reset-header {
  width: 100%;
  text-align: center;
  margin-top: 0.8rem;
}

.btn {
  font-size: 14px;
  color: #ff8622;
  border: 1px solid #ff8622;
  border-radius: 2px;
  cursor: pointer;
}

.active-btn {
  font-size: 14px;
  color: #ffffff;
  border-radius: 2px;
  background: #ff8622;
  cursor: pointer;
}

.btn.mobile-btn {
  padding: 0.16rem 0.4rem;
  margin-left: 0.4rem;
  display: inline-block;
  line-height: 18px;
}

.active-btn.confirm-btn {
  padding: 0.16rem 0.54rem;
}

.form-wrapper {
  margin-top: 0.62rem;
}

>>>.form-wrapper .ivu-form-item-label {
  font-size: 14px;
  color: #666666;
}

>>>.form-wrapper .ivu-form-item-label {
  line-height: 16px;
}

.form-wrapper .form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.form-wrapper .form-group .input-wrap {
  width: 4.45rem;
  margin-right: 0.2rem;
}

.form-wrapper .form-group .tip-wrapper {
  font-size: 14px;
  color: #999999;
}

>>>.form-wrapper .form-group .ivu-input:focus,
>>>.reset .ivu-input:focus {
  border: 1px solid #ff8622 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}

>>>.form-wrapper .form-group .ivu-input:hover,
>>>.reset .ivu-input:hover {
  border-color: #ff8622;
}

>>>.form-wrapper .form-group .ivu-radio-checked .ivu-radio-inner {
  border-color: #ff8622;
}

>>>.form-wrapper .form-group .ivu-radio-checked .ivu-radio-inner:after {
  background-color: #ff8622;
}

>>>.form-wrapper .form-group .ivu-radio-checked:hover .ivu-radio-inner {
  border-color: #ff8622;
}

>>>.ivu-radio-focus {
  z-index: 1;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/setting/Index.vue